import React from "react";
import { Link } from "react-router-dom";

const LockIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#f0932b"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

/**
 * Same locked overlay pattern as FeatureLock — dimmed content + lock icon link.
 * Use `inline` for buttons and compact controls (no full-width stretch).
 */
const UpgradeLock = ({ locked, children, label = "Upgrade to unlock", inline = false }) => {
  if (!locked) {
    return children;
  }

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        width: inline ? "auto" : "100%",
        paddingBottom: inline ? 22 : 0,
      }}
    >
      <div style={{ opacity: 0.45, pointerEvents: "none" }}>{children}</div>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          zIndex: 10,
        }}
      >
        <Link
          to="/admin/manage-subscription"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textDecoration: "none",
            color: "#333",
          }}
        >
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              background: "rgba(240, 147, 43, 0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 6,
            }}
          >
            <LockIcon />
          </div>
          <span
            style={{
              fontSize: 11,
              fontWeight: 600,
              color: "#f0932b",
              textAlign: "center",
              lineHeight: 1.3,
              whiteSpace: "nowrap",
            }}
          >
            {label}
          </span>
        </Link>
      </div>
    </div>
  );
};

export default UpgradeLock;
